<div class="coc-sample-table-widget" [innerHTML]="html"></div>
